<div class="row">
  <card [name]="'Create moderator'" class="col col-120 col-lg-100 col-xl-90">
    <div card content class="row">
      <moderator-form class="col col-120 col-lg-100 col-xl-80"
                      (submited)="onSubmit($event)">
        <button class="btn btn-success float-right" type="submit">Create</button>
<!--        <a class="btn btn-outline-info float-right ml-2" type="button" (click)="back($event)">Back</a>-->
      </moderator-form>
    </div>
  </card>
</div>
